<template>
  <div>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <ul class="error_list">
                    <li
                        v-for="(item,index) in errorData"
                        :key="index"
                    >
                        {{item}}
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
                <app-button
                    value="入力画面に戻る"
                    @button-click="errorHide"
                    this-class="btn_cancel"
                />
            </div>
        </div>
    </div>
  </div>
</template>


<script>
/**
 * エラー表示
 * 
 * [算出プロパティ]
 * errorData ... エラーの配列
 * 
 * [イベント処理]
 * 戻るボタンクリック時 ... this.$emit('modal-error-hide')
 * 
 * [利用例]
 * <modal-error
 *    v-if="modalErrorShow"
 *    @modal-error-hide="hideError"
 * />
 */
import { mapGetters } from 'vuex'

export default {
    name:"ModalError",
    computed: {
        ...mapGetters('error', {
            /**
             * エラーの配列
             */
            errorData:'getError',
        })
    },
    methods: {
        /**
         * 非表示にする
         */
        errorHide(){
            this.$emit('modal-error-hide')
        }
    },
}
</script>

<style lang="scss" scoped>
div.modal-dialog{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 80vh;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    overflow-y:auto;
    -ms-overflow-style:none;
    top: 0;
    z-index: 9999;
}
_:-ms-lang(x)::-ms-backdrop, div.modal-dialog {
    overflow: hidden;
}
.modal-content{
    display: block;
    width: 75%;
    max-height: 90vh;
    margin:  65px auto;
    padding: 1em 4em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
}
.modal-header{
    display: -ms-grid;
    display: grid;
    grid-template-columns: 10em 1fr;
    -ms-grid-columns: 10em 1fr;/* IE11 */
    align-items: center;
}
.title{
    grid-column: 1;
    -ms-grid-column: 1;
}
.modal-lang{
    grid-column: 2;
    -ms-grid-column: 2;
    text-align: right;
    label{
        margin: 0 8px;
        &:after{
            display: none;
        }
        &:before{
            display: none;
        }
    }
}
.modal-body{
    display: block;
    height: auto;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
}
.modal-body::-webkit-scrollbar {
  display: none;
}
.modal-footer{
    display: flex;
    justify-content: flex-end;
}
ul{
    padding-inline-start:  20px;
}
li{
    padding: 4px 0;
}
</style>



